export enum FilterType {
  FAVOTRITEGROUPS = "favouriteGroups",
  USEFILTERS = "filter",
}

export interface IFilter {
    engagement: number | null,
    maxFollowers: number | null,
    minFollowers: number | null,
    platform: string | null,
    locationPreference: string[],
    gender: string | null,
    minParticipatedCampaigns: number | null,
    maxParticipatedCampaigns: number | null
}